import React from 'react'
import cx from 'classnames'

import SrcSize from 'components/ui/SrcSize/SrcSize'

import s from './Image.scss'


const CartOrderItemImage = ({ className, url, image, imageCheckout }) => {
  const node = url ? 'a' : 'div'

  let props = {
    className: cx(className, s.image),
  }

  if (url) {
    props = {
      ...props,
      href: url,
      target: '_blank',
    }
  }

  const imageSrc = imageCheckout || image

  return (
    <SrcSize src={imageSrc} h={100}>
      {
        (src) => React.createElement(node, {
          ...props,
          style: {
            backgroundImage: `url(${encodeURI(src)})`,
          },
        })
      }
    </SrcSize>
  )
}


export default React.memo(CartOrderItemImage)
